














import Vue from 'vue'
import CCardBase from './_cCardBase.vue'

export default Vue.extend({
  name: 'frame-card-content',
  components: { CCardBase },
  props: {
    item: { type: Object, required: true },
    small: { type: Boolean },
    hover: { type: Boolean },
  },
})
